<p-dialog [(visible)]="visible" [modal]="true" [closable]="false"
    [style]="{ width: '98vw', maxWidth: '500px', height: '90vh', maxHeight: '750px' }"
    [contentStyle]="{ padding: '0', margin: '0' }" (onHide)="onDialogHide()">
    <ng-template #headless>
        <button class="close-button" id="closeButton" mat-icon-button (click)="onDialogHide()">×</button>
        <iframe id="frontstream_embedded_frame"
            class="w-full h-full top-0 left-0 flex items-center justify-center" allow="payment *" scrolling="yes"
            marginheight="0" marginwidth="0" [src]="iframeUrlSafe" style="border: none;"></iframe>
    </ng-template>
</p-dialog>

<!--
<div *ngIf="visible" class="fixed inset-0 z-[1040] flex items-center justify-center">
    <div
        class="relative bg-white w-[370px] h-[880px] md:w-[500px] md:h-[880px] rounded-lg shadow-2xl overflow-hidden z-[1050]">


        <button (click)="closeIframe()"
            class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold z-[1060]">
            &times;
        </button>


        <iframe id="frontstream_embedded_frame" class="w-full h-full" allow="payment *" scrolling="yes" marginheight="0"
            marginwidth="0" [src]="iframeUrlSafe">
        </iframe>
    </div>
</div> -->
